export default __webpack_public_path__ + "static/media/pin.3e28b9d1.svg";